import moment from 'moment';
import { processChannelCountryAnalytics } from '../helpers/youtubeResponseHandler';

export const getChannelCountryDemographics = async youtubeChannelId => {
  const endDate = getEndDate();
  const countryResponse = await window.gapi.client.youtubeAnalytics.reports.query(
    {
      ids: `channel==${youtubeChannelId}`,
      dimensions: 'country',
      metrics: 'views',
      startDate: '2015-01-01',
      endDate: endDate,
      maxResults: 10
    }
  );

  return processChannelCountryAnalytics(countryResponse);
};

const getEndDate = () => {
  return moment().format('YYYY-MM-DD');
};



// WEBPACK FOOTER //
// ./src/services/youtubeAnalyticsService.js